import { AztecProduct, BreadcrumbDirection } from 'types/models';
import {
  ChoiceTransitionDiv,
  PortionItem,
} from 'menu/components/MenuModal/ModalBody';
import { sortPortionsByPriceThenId, updatePortionQuantity } from 'menu/utils';
import { useMenuModal } from 'contexts/MenuModalContext';

interface SelectPortionModalProps {
  aztecProduct: AztecProduct;
  updateAztecProduct: (product: AztecProduct) => void;
}

export const SelectPortionModal: React.FC<SelectPortionModalProps> = ({
  aztecProduct,
  updateAztecProduct,
}) => {
  const { setDirection } = useMenuModal();
  const portionArray = Object.values(aztecProduct.portions);

  const onPortionClick = (portionId: number) => {
    setDirection(BreadcrumbDirection.Forward);
    const updatedProduct = updatePortionQuantity(aztecProduct, portionId, 1);
    updateAztecProduct(updatedProduct);
  };

  const portionComponents = sortPortionsByPriceThenId(portionArray).map(
    (portion) => {
      return (
        <PortionItem
          key={`${aztecProduct.id}-${portion.id}`}
          portion={portion}
          onPortionClick={onPortionClick}
        />
      );
    },
  );

  return (
    <ChoiceTransitionDiv classNames="portion-list" ignoreEntry={true}>
      {portionComponents}
    </ChoiceTransitionDiv>
  );
};
